<template>
  <div id="goods">
    <div>
      <el-select v-model="queryBycompanyType" placeholder="请选择" @change="handleChangeCompanyType" clearable>
        <el-option
          v-for="n in goodsType"
          :key="n.key"
          :label="n.name"
          :value="n.id">
        </el-option>
      </el-select>
      <el-select v-model="queryBycompanyStatus" placeholder="请选择" @change="handleChangeCompanyStatus">
        <el-option
          v-for="n in companyStatus"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select>
      <div style="display:inline-block">
        <el-input v-model="queryBycompanySearchkey" placeholder="请输入型号" @change="handleChangeCompanySearchkey"></el-input>
      </div>
    </div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加商品</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="cnName"
          label="商品中文名"
          width="">
        </el-table-column>
        <el-table-column
          prop="enName"
          label="商品英文名"
          width="">
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="类型"
          width="">
        </el-table-column>
        <el-table-column
          prop="model"
          label="型号"
          width="">
        </el-table-column>

        <el-table-column
          label="包装规格">
          <template slot-scope="scope">
             <div>{{ scope.row.packWeight + scope.row.goodsSpec }}</div>
           </template>
        </el-table-column>

        <el-table-column
          prop="brand"
          label="品牌"
          width="">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="生产商"
          width="">
        </el-table-column>
        <el-table-column
          prop="minOrder"
          label="最小起订量"
          width="">
        </el-table-column>
        <el-table-column
          prop="price"
          label="参考价"
          width="">
        </el-table-column>
        <el-table-column
          prop="application"
          label="用途"
          width="">
        </el-table-column>
        <!-- <el-table-column
          label="创建时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.createTime) }}</div>
           </template>
        </el-table-column> -->
        <el-table-column
          width="240"
          label="操作选项">
           <template slot-scope="scope">
             <el-button
              size="mini"
              type="primary"
              @click="handlequery(scope.row)">查看详情</el-button>
            <el-button
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handelCurrentChange"
          :current-page="currentpageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="53%"
        center>
        <el-form :model="form" label-width="160px" class="detail" :rules="rules">
          <el-form-item label="商品名称中文" :label-width="formLabelWidth">
            <el-input v-model="form.cnName" v-if="!isshowgoodsDetail"></el-input>
            <div v-if="isshowgoodsDetail">{{form.cnName}}</div>
          </el-form-item>
          <el-form-item label="商品名称英文" :label-width="formLabelWidth">
            <el-input v-model="form.enName" v-if="!isshowgoodsDetail"></el-input>
             <div v-if="isshowgoodsDetail">{{form.enName}}</div>
          </el-form-item>
          <el-form-item label="商品类型" :label-width="formLabelWidth" prop="typeId">
            <el-select v-model="form.typeId" placeholder="请选择" v-if="!isshowgoodsDetail">
              <el-option
                v-for="n in goodsType"
                :key="n.key"
                :label="n.name"
                :value="n.id">
              </el-option>
            </el-select>
             <div v-if="isshowgoodsDetail">{{form.typeName}}</div>
          </el-form-item>

          <el-form-item label="商品型号" :label-width="formLabelWidth" prop="model">
            <el-input v-model="form.model" v-if="!isshowgoodsDetail"></el-input>
             <div v-if="isshowgoodsDetail">{{form.model}}</div>
          </el-form-item>

           <el-form-item label="供货商" :label-width="formLabelWidth" prop="companyId">
            <div v-if="isshowgoodsDetail">{{form.companyName}}</div>
            <el-select v-model="form.companyId" placeholder="请选择" v-if="!isshowgoodsDetail">
              <el-option
                v-for="item in companyList"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="托盘重量" :label-width="formLabelWidth" prop="minOrder">
            <el-input v-model="form.trayWeight" v-if="!isshowgoodsDetail">
               <el-button slot="append">公斤/托</el-button>
            </el-input>
             <div v-if="isshowgoodsDetail">{{form.trayWeight}}</div>
          </el-form-item>

          <!-- <el-form-item label="" :label-width="formLabelWidth">
            <el-input v-model="form.brand" v-if="!isshowgoodsDetail"  disabled></el-input>
             <div v-if="isshowgoodsDetail">{{form.brand}}</div>
             <div></div>
          </el-form-item> -->
          
          <el-form-item label="包装规格" :label-width="formLabelWidth" prop="packWeight">
            <el-input v-model="form.packWeight" v-if="!isshowgoodsDetail" class="jdjdjdj">
               <el-button slot="append">
                  <el-select v-model="form.spec" placeholder="请选择" v-if="!isshowgoodsDetail">
                    <el-option
                      v-for="item in goodsSpecList"
                      :key="item.key"
                      :label="item.goodsSpec"
                      :value="item.code">
                    </el-option>
                  </el-select>
               </el-button>
            </el-input>
            
             <div v-if="isshowgoodsDetail">{{form.packWeight + form.goodsSpec}}</div>
          </el-form-item>

          <el-form-item label="最小起订量" :label-width="formLabelWidth" prop="minOrder">
            <el-input v-model="form.minOrder" v-if="!isshowgoodsDetail">
               <el-button slot="append">公斤</el-button>
            </el-input>
             <div v-if="isshowgoodsDetail">{{form.minOrder}}</div>
          </el-form-item>

          <el-form-item label="参考价" :label-width="formLabelWidth" prop="price">
            <el-input v-model="form.price" v-if="!isshowgoodsDetail"></el-input>
             <div v-if="isshowgoodsDetail">{{form.price}}</div>
          </el-form-item>

          <el-form-item label="用途" :label-width="formLabelWidth" prop="application">
            <el-input v-model="form.application" v-if="!isshowgoodsDetail"></el-input>
             <div v-if="isshowgoodsDetail">{{form.application}}</div>
          </el-form-item>

          <el-form-item label="产品规格书" :label-width="formLabelWidth">
            <div v-if="isshowgoodsDetail">
              <el-button type="primary" @click="downloadpdf(form.specification)" >预览下载</el-button>
            </div>
            <el-upload
              class="upload-demo"
              :data="qiniu"
              :limit="1"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :file-list="specification"
              :on-remove="handleOnRemove"
              :multiple="false"
              v-if="!isshowgoodsDetail"
              :before-upload="handleBeforeUpload"
              :on-success="handleOnSuccess"
            >
            <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="工艺流程书" :label-width="formLabelWidth">
            <div v-if="isshowgoodsDetail">
              <el-button type="primary" @click="downloadpdf(form.processBook)" >预览下载</el-button>
            </div>
            <el-upload
              class="upload-demo"
              :data="qiniu"
              :limit="1"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :file-list="processBook"
              :on-remove="handleOnRemove2"
              :multiple="false"
              v-if="!isshowgoodsDetail"
              :before-upload="handleBeforeUpload2"
              :on-success="handleOnSuccess2"
            >
            <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { goodsfindAll, qiniugetDown, goodsqueryById, goodsadd, goodsupdateById, goodsdelete, companytypefindAll, goodsTypefindAll, findAll, qiniuupload, goodsSpec} from '../../api'
import utils from '../../../public/utils'
import moment from 'moment'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      goodsSpecList: [], //  规格列表
      processBook: [],
      specification: [],
      total: 0,
      companyStatus: [ //  公司状态列表
        {
          value: null,
          label: '所有'
        },
        {
          value: 1,
          label: '有效'
        },
        {
          value: 2,
          label: '无效'
        }
      ],
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      currentpageIndex: 1,
      currentpageSize: 10,
      uploadUrl: '', //  上传地址前缀
      isshowgoodsDetail: false, //  默认不展示商品详情
      queryBycompanyStatus: 1, //  公司状态默认有效
      queryBycompanySearchkey: '', //  类型
      goodsType: [], //  商品类型列表
      queryBycompanyType: null, //  公司类型默认有效
      companyList: [], //  公司列表
      centerDialogVisible: false,
      form: { //  新增初始化form
        cnName: 'cnName',
        enName: 'enName',
        typeId: 1,
        typeName: 'typeName',
        model: 'model',
        brand: 'brand',
        companyId: 1,
        packWeight: 1,
        application: 'application',
        minOrder: 1,
        price: 1,
        companyName: 'companyName',
        specification: 'specification',
        processBook: 'processBook',
      },
      formLabelWidth: '180px',
      sts: 0, //  0 添加, 1 编辑
      title: '', //  添加窗口标题
      rules: {
        typeId: [
          { required: true, message: '请选择商品类型', trigger: 'change' },
        ],
        model: [
          { type: 'string', required: true, message: '请输入商品型号', trigger: 'blur' },
        ],
        companyId: [
          { required: true, message: '请选择公司类型', trigger: 'change' },
        ],
        packWeight: [
          { type: 'string', required: true, message: '请输入商品规格', trigger: 'blur' },
        ],
        minOrder: [
          { type: 'string', required: true, message: '请输入最小起订量', trigger: 'blur' },
        ],
        price: [
          { type: 'string', required: true, message: '请输入参考价', trigger: 'blur' },
        ],
        application: [
          { type: 'string', required: true, message: '请输入用途', trigger: 'blur' },
        ],
        specification: [
          { required: true, message: '请上传规格书', trigger: 'change' },
        ],
      }
    }
  },
  mounted () {
    this.getgoodsTypefindAll()
    this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
    this.getToken()
  },
  methods: {
     getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'crm-commodity')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    handelCurrentChange (i) { // 分页
      this.currentpageIndex = i
      this.getgoodsfindAll()
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let para = new URLSearchParams()
      para.append('baseUrl', w)
      qiniugetDown(para).then(data => {
        console.log(data.data)
        window.open(data.data)
      })
    },
    getgoodsSpec () { //  规格列表
      let para = {}
      goodsSpec(para).then(data => {
        console.log(data)
        this.goodsSpecList = data.data.data
      })
    },
    handleBeforeUpload (file) { //  生产规格书
      this.qiniu.key = `specification${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList) { //  上传成功之后
      this.form.specification = this.uploadUrl + response.key
      console.log(this.form.specification)
      this.specification.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove (file, fileList) {
      this.specification = []
    },
    handleBeforeUpload2 (file) { //  工艺流程书
      this.qiniu.key = `processBook${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess2 (response, file, fileList) { //  上传成功之后
      this.form.processBook = this.uploadUrl + response.key
      this.processBook.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove2 (file, fileList) {
      this.processBook = []
    },
    handlequery (row) { //  详情
       this.centerDialogVisible = true
       this.isshowgoodsDetail = true
       this.title = '商品详情'
       this.sts = 2
       this.form = row
       this.processBook = []
       this.specification = []
       this.processBook.push({
         name: this.formatName(this.form.processBook),
         url: this.form.processBook
        })
       this.specification.push({
         name: this.formatName(this.form.specification),
         url: this.form.specification
        })
    },
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      this.isshowgoodsDetail = false
      console.log(ind, row)
      this.getgoodsSpec()
      this.getfindAll(1, 2)
      if (ind === 1) {
        this.title = '编辑商品'
        this.form = row
        this.sts = 1
      } else {
        this.title = '新增商品'
        this.form = {}
        this.specification = []
        this.processBook = []
        this.form = {
          specification: '',
          processBook: '',
          spec: 1,
          typeId: '',
          companyId: ''
        }
        this.sts = 0
      }
    },
    handlesuccess (sts) { //  提交修改信息
      let para = new URLSearchParams(this.form)
      if (sts === 0) {
        goodsadd(para).then(data => {
          console.log(data)
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else if (sts === 1) {
        para.append('id', this.form.id)
        //  修改信息
        goodsupdateById(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        //  查看详情
        this.centerDialogVisible = false
      }
    },
    handleDelete (ind, row) { //  删除
      console.log(ind, row)
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( () => {
        let para = new URLSearchParams()
        para.append('id', row.id)
        goodsdelete(para).then( data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    getgoodsfindAll (t, s, k) { //  查询所有商品
      let params = {
        typeId: this.queryBycompanyType,
        status: this.queryBycompanyStatus,
        searchKey: this.queryBycompanySearchkey,
        pageIndex: this.currentpageIndex,
        pageSize: this.currentpageSize
      }
      console.log(params)
      goodsfindAll(params).then(data => {
        console.log(data)
        this.list = data.data.data.rows
        this.total = data.data.data.total
      })
    },
    getgoodsTypefindAll (s) { //  查询商品类型列表
      let para = {
        status: 1
      }
      goodsTypefindAll(para).then(data => {
        console.log(data)
        this.goodsType = data.data.data.child
      })
    },
    handleChangeCompanyStatus (val) { //  根据公司状态查询公司
      // this.queryBycompanyStatus = val
      this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
    },
    handleChangeCompanyType (val) { //  根据公司类型查询公司
      // this.queryBycompanyType = val
      this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
    },
    handleChangeCompanySearchkey (val) {
      this.getgoodsfindAll(this.queryBycompanyType, this.queryBycompanyStatus, this.queryBycompanySearchkey)
    },
    formatName (s) {
      // "http://seatransportation.cuican520.cn/packingList201902261115793321.zip"
      return s.substr(38)
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    getfindAll (s, t) { //  查询全部公司
      let para = {
        status: s,
        typeId: t
      }
      findAll(para).then(data => {
        console.log(data)
        this.companyList = data.data.data
      })
    },
  },
}
</script>
<style lang="stylus">
#goods
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
  .el-rate
    line-height 2.5
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .jdjdjdj .el-input-group__append
    width 60px
  .detail>div
    display inline-block
    width 49%
    // border-top 1px solid #ccc
    margin-bottom 0
    padding 10px 0
    // text-align center
</style>
